import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsV2 } from './analyticsV2';

const AnalyticsV2Provider: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    analyticsV2.initialize();
  }, []);

  useEffect(() => {
    analyticsV2.startPageView(
      location.pathname,
      location.search,
      document.title
    );

    const tickerMatch = location.pathname.match(/^\/stocks\/([^/]+)$/i);
    if (tickerMatch) {
      analyticsV2.track('ticker_viewed', {
        ticker: decodeURIComponent(tickerMatch[1]).toUpperCase(),
      });
    }

    const dcfMatch = location.pathname.match(/^\/start-analysis\/([^/]+)$/i);
    if (dcfMatch) {
      analyticsV2.track('dcf_started', {
        ticker: decodeURIComponent(dcfMatch[1]).toUpperCase(),
      });
    }
    // Query-string changes inside a route (for example DCF sliders) are events,
    // not new page views. Every pathname is still tracked globally.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};

export default AnalyticsV2Provider;
